module.exports = __webpack_public_path__ + "img/credit-card (4).0d8f19b8.svg";